import Contribution from "./models/Contribution";
import Goal from "./models/Goal";

export function firstContributionForToday(goal: Goal): Contribution | undefined {
    const today = new Date(); // Get the current date
    const contributions = goal.userContributions || []; // Assuming contributions is an array
    let omg = contributions.find((contribution) => {
      // Check if any contribution date matches today's date
      const contributionDate = new Date(contribution.date);
      if(contributionDate.getDate() === today.getDate() &&
      contributionDate.getMonth() === today.getMonth() &&
      contributionDate.getFullYear() === today.getFullYear()){
        return true;
      }
    return null;});
    return omg;
  }

  export function isSameDate(date1:any, date2:any) {
    return date1.getFullYear() === date2.getFullYear() &&
           date1.getMonth() === date2.getMonth() &&
           date1.getDate() === date2.getDate();
}


export function dayString(date: Date){
  let daysOfWeek = {
    english:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
    japanese:["日","月","火","水","木","金", "土"]
  };
  return daysOfWeek.english[date.getDay()];
}